export enum AccessLevel {
  SUPER_ADMIN = 'SUPER_ADMIN',
  RESELLER_ADMIN = 'RESELLER_ADMIN',
  COMPANY_ADMIN = 'COMPANY_ADMIN',
  COMPANY_USER = 'COMPANY_USER',
  COMPANY_REPORT_USER = 'COMPANY_REPORT_USER',
  SELF_SERVICE_ADMIN = 'SELF_SERVICE_ADMIN',
  GUEST = 'GUEST'
}
